module.exports = __webpack_public_path__ + "assets/chakra-ui.9d5f8d23.svg";